module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.9e0d8605.woff2";